<template>
  <div>
    <iframe :src="iframeSrc"></iframe>
  </div>
</template>

<script>

import Cookies from "js-cookie";

export default {
  computed: {
    iframeSrc() {
      const baseUrl = process.env.VUE_APP_IFRAME_BASE_URL;
      return `${baseUrl}/#/chat?X-Access-Token=${Cookies.get('X-Access-Token')}`;
    }
  }
}
</script>

<style scoped
       lang="less">
iframe {
  width: 100%;
  height: calc(100vh - 118px);
  border: 0;
  border-radius: 6px;
}
</style>
